import { naturalCompare } from "./../helpers";
import { IDir, ISortMode } from "./../types";

type ChangeString = (a: string) => string | number;

export class Sort {
	sort(array: any[], by: ISortMode) {
		if (by.rule && typeof by.rule === "function") {
			this._sort(array, by);
		} else if (by.by) {
			by.rule = (a: any, b: any) => {
				const aa = this._checkVal(by.as, a[by.by]);
				const bb = this._checkVal(by.as, b[by.by]);
				return naturalCompare(aa.toString(), bb.toString());
			};
			this._sort(array, by);
		}

	}
	private _checkVal(method: ChangeString, val: string | number) {
		return method ? method.call(this, val) : val;
	}
	private _sort(arr: any[], conf: ISortMode): any[] {
		const dir: IDir = {
			asc: 1,
			desc: -1
		};
		return arr.sort((a: any, b: any) => {
			return conf.rule.call(this, a, b) * (dir[conf.dir] || dir.asc);
		});
	}
}